import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Component } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { HomeModule } from './modules/home/home.module';
import { LoginModule } from './modules/login/login.module';
import { AuthenticationService } from './services/auth/authentication.service';
import { TokenStorage } from './storages/token.storage';
import { TokenInterceptor } from './interceptors/token-interceptor';
import { AuthenticationGuard } from './guards/authentication.guard';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { ImportAndExportDataModule } from './modules/user/importAndExportData.module';
import { HomeNavigateBarComponent } from './modules/home/components/home-navigate-bar/home-navigate-bar.component';
import { MailingPageModule } from './modules/mailing-list/mailing-page.module';
import { MessageErrorDownload } from './modules/modal-window/message-error-download-popup/messageErrorDownload-popup.component';
import { InfoModule } from './modules/help/components/info.module';
import { DataTablesModule } from 'angular-datatables';
import { MessageWithTextPopup } from './modules/modal-window/message-with-text-popup/message-with-text-popup.component';
import { OtherKpPageModule } from './modules/other-kp/other-kp-page.module';
import { LoggingService } from './services/logging.service';
import { ComponentRegistryService } from './modules/home/services/component-registry.service';

@NgModule({
  declarations: [
    AppComponent,
    HomeNavigateBarComponent,
    MessageErrorDownload,
    MessageWithTextPopup
  ],
  imports: [
    BrowserModule,
    DataTablesModule,
    AppRoutingModule,
    HttpClientModule,
    HomeModule,
    LoginModule,
    FormsModule,
    BrowserAnimationsModule,
    ToastModule.forRoot(),
    ImportAndExportDataModule,
    MailingPageModule,
    OtherKpPageModule,
    InfoModule
  ],
  providers: [
    AuthenticationService,
    AuthenticationGuard,
    ComponentRegistryService,
    LoggingService,
    TokenStorage,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts